import {
  OR_RECEIVE_HOLIDAYS,
  OR_RECEIVE_HOLIDAYS_ERROR,
  OR_REQUEST_HOLIDAYS,
  OR_SHOW_ADD_HOLIDAY_MODAL,
  OR_HIDE_ADD_HOLIDAY_MODAL,
  OR_REQUEST_ADD_HOLIDAY,
  OR_ADD_HOLIDAY_SUCCESS,
  OR_ADD_HOLIDAY_ERROR,
} from '../../../actions/management/orSettings';

export const initialState = {
  holidaysList: [],
  isFetchingHolidays: false,
  isFetchingHolidaysError: false,

  isAddHolidaysModalVisible: false,

  isAddHolidayPending: false,
  isAddHolidayError: false,
};

export default function holidaysReducer(state = initialState, action) {
  switch (action.type) {
    case OR_REQUEST_HOLIDAYS:
      return { ...state, isFetchingHolidays: true };
    case OR_RECEIVE_HOLIDAYS:
      return {
        ...state,
        holidaysList: action.data,
        isFetchingHolidays: false,
        isFetchingHolidaysError: false,
      };
    case OR_RECEIVE_HOLIDAYS_ERROR:
      return {
        ...state,
        holidaysList: [],
        isFetchingHolidays: false,
        isFetchingHolidaysError: true,
      };
    case OR_SHOW_ADD_HOLIDAY_MODAL:
      return { ...state, isAddHolidaysModalVisible: true };
    case OR_HIDE_ADD_HOLIDAY_MODAL:
      return { ...state, isAddHolidaysModalVisible: false };
    case OR_REQUEST_ADD_HOLIDAY:
      return { ...state, isAddHolidayPending: true };
    case OR_ADD_HOLIDAY_SUCCESS:
      return {
        ...state,
        isAddHolidayPending: false,
        isAddHolidayError: false,
        isAddHolidaysModalVisible: false,
      };
    case OR_ADD_HOLIDAY_ERROR:
      return { ...state, isAddHolidayPending: false, isAddHolidayError: true };
    default:
      return state;
  }
}
